<template>
    <div class="categoryselect flex">
        <div class="category__image bg-cover" :style="categoryImage"></div>
        <ul>
            <li>
                <div class="cat__label" @click="select();" @mouseenter="toggleCat('', 'open')">
                    {{ $t('products.all_products') }}
                </div>
            </li>
            <li v-for="cat in categories" :key="'cat_' + cat.id">
                <div v-if="cat.children && cat.children.length" class="cat__label" @click="toggleCat(cat, 'open')"
                    @mouseenter="toggleCat(cat, 'open')">
                    {{ inlinedata(cat, 'naam', currentlang) }}
                </div>
                <div v-else @mouseenter="toggleCat(cat, 'open')" @click="select(cat.id)" class="cat__label">
                    {{ inlinedata(cat, 'naam', currentlang) }}
                </div>
                <ul v-if="cat.children && cat.children.length && cat.id === openCat.id">
                    <li>
                        <div class="cat__label" @click="select(cat.id);">
                            {{ $t('products.all') }} {{ inlinedata(cat, 'naam', currentlang) }}
                        </div>
                    </li>
                    <li v-for="subcat in cat.children" :key="'cat_' + cat.id + '_sub_' + subcat.id"
                        @click="select(subcat.id)">
                        <div class="cat__label">
                            {{ inlinedata(subcat, 'naam', currentlang) }}
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Categoryselect',
    props: {
        categories: Array,
        value: Array,
    },
    data() {
        return {
            openCat: {},
        };
    },
    methods: {
        toggleCat(cat, action) {
            if (!action) {
                this.openCat = (this.openCat.id === cat.id) ? '' : cat;
            } else {
                this.openCat = (action === 'open') ? cat : '';
            }
        },

        select(id) {
            if (id) {
                this.$emit('input', [id]);
            } else {
                this.$emit('input', []);
            }
            this.$emit('close');
        },
    },
    computed: {
        currentlang() {
            return this.$store.getters['Language/current'];
        },

        categoryImage() {
            let image = this.webdata('kings_garden_collection.afbeelding2');
            if (this.openCat.afbeelding1) {
                image = this.openCat.afbeelding1;
            }
            return { backgroundImage: `url(${image})` };
        },
    },
};
</script>

<style>
.tile.-large .tile__dropdown {
    max-width: 80rem;
    overflow: hidden;
}

.categoryselect {
    align-items: stretch;
}

.category__image {
    flex: 0 0 30%;
    background-color: var(--color-bg);
    margin: -1.2rem 0 -1.2rem -1.6rem;
    border-radius: 0.8rem 0 0 0.8rem;
    position: relative;
    z-index: 10;
}

.categoryselect>ul {
    line-height: 4rem;
    flex: 1 0 auto;
    position: relative;
    margin-right: -1.6rem;
}

.categoryselect li {
    display: block;
    width: 100%;
}

.categoryselect li .cat__label {
    padding: 0 1.6rem;
    cursor: pointer;
    transition: background .3s ease;
}

.categoryselect li:hover>.cat__label {
    background-color: var(--color-accent-dark);
    color: var(--color-white);
}


@media (max-width: 49.9em) {
    .categoryselect>ul {
        margin-left: -1.6rem;
    }

    .category__image {
        display: none;
    }

    .categoryselect ul ul li {
        padding-left: 1.2rem;
    }
}

@media (min-width: 50em) {
    .categoryselect>ul>li {
        width: 50%;
    }

    .categoryselect ul ul {
        position: absolute;
        left: 50%;
        width: 50%;
        top: -1.2rem;
        bottom: -1.2rem;
        padding: 1.2rem 0;
        background: white;
        border-left: 0.1rem solid #d1d1d1;
        box-shadow: -0.3rem 0 0.3rem rgba(0, 0, 0, 0.1);
    }
}</style>
